import Draggable from "react-draggable";
import * as tf from "@tensorflow/tfjs";
import "./cephalo.css";
import { useEffect, useState } from "react";
import {
  Button,
  ConfigProvider,
  Descriptions,
  message,
  notification,
} from "antd";
//redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useNavigate, useParams } from "react-router-dom";
import Url from "../../../apiCall/UrlConfig";

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const LateralCephaloAnaLysis = (props) => {
  let navigate = useNavigate();
  const { id, idAnalyses } = useParams();
  const [pointPositions, setPointPositions] = useState({
    S: {
      x: 259,
      y: 389,
    },
    N: {
      x: 587,
      y: 256,
    },
    Me: {
      x: 622,
      y: 870,
    },
    Go: {
      x: 248,
      y: 773,
    },
    Gn: {
      x: 636,
      y: 842,
    },
    Or: {
      x: 547,
      y: 431,
    },
    Po: {
      x: 108,
      y: 462,
    },
    ANS: {
      x: 635,
      y: 541,
    },
    PNS: {
      x: 388,
      y: 561,
    },
    A: {
      x: 652,
      y: 612,
    },
    B: {
      x: 624,
      y: 720,
    },
    Ar: {
      x: 182,
      y: 543,
    },
    OP1: { x: 425, y: 658 },
    // OP2: { x: 655, y: 670 },
    POG: { x: 624, y: 811 },
    U1: { x: 669, y: 690 },
    U2: { x: 623, y: 570 },
    L1: { x: 646, y: 655 },
    L2: { x: 583, y: 755 },
    SoftG: { x: 583, y: 755 },
    SoftPn: { x: 583, y: 755 },
    SoftPOG: { x: 583, y: 755 },
    SoftMe: { x: 583, y: 755 },
    SoftULip: { x: 583, y: 755 },
    SoftLLip: { x: 583, y: 755 },
    Ruller1: { x: 10, y: 10 },
    Ruller2: { x: 10, y: 100 },
  });

  const [lateralPhoto, setLateralPhoto] = useState(null);

  const [LateralCephaloAnaLysis, setCephaloAnalysis] = useState([]);

  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    console.log(pointPositions);
    _calculate();
  }, [pointPositions]);
  const _calculate = () => {
    console.log(pointPositions);
    const pointS = pointPositions["S"];
    const pointGo = pointPositions["Go"];
    const pointMe = pointPositions["Me"];
    const pointN = pointPositions["N"];
    const pointGn = pointPositions["Gn"];
    const pointA = pointPositions["A"];
    const pointB = pointPositions["B"];
    const pointAr = pointPositions["Ar"];
    const pointOr = pointPositions["Or"];
    const pointPo = pointPositions["Po"];
    //calculate jarobak index
    const distanceSGo = calculateDistance(pointS, pointGo);
    const distanceNMe = calculateDistance(pointN, pointMe);
    if (distanceSGo == 0 || distanceNMe == 0) {
      message.error("Please select all the points");
      return;
    }
    const jarobakIndex = (distanceSGo / distanceNMe) * 100;

    //calculate angle
    const YAxis = calculateAngle(pointN, pointS, pointGn);
    const ANBDegree = calculateSignedAngle(pointA, pointN, pointB);
    const ArticularAngle = calculateAngle(pointS, pointAr, pointGo);
    const SNAangle = calculateAngle(pointS, pointN, pointA);
    const SNBangle = calculateAngle(pointS, pointN, pointB);
    const SNFHAngle = calculateAngleBetweenLines(
      pointS,
      pointN,
      pointPo,
      pointOr
    );
    const SN_GoMeAngle = calculateAngleBetweenLines(
      pointS,
      pointN,
      pointGo,
      pointMe
    );
    const SN_GoGn = calculateAngleBetweenLines(
      pointS,
      pointN,
      pointGo,
      pointGn
    );

    const FHMeGo = calculateAngleBetweenLines(
      pointPo,
      pointOr,
      pointGo,
      pointMe
    );

    console.log("Jarobak Index:", jarobakIndex);
    console.log("YAxis:", YAxis);
    console.log("ANB", ANBDegree);
    console.log("Articular Angle", ArticularAngle);
    console.log("SNA", SNAangle);
    console.log("SNB", SNBangle);
    console.log("SNFHAngle", SNFHAngle);
    setCephaloAnalysis([
      {
        key: "jarobak Index",
        label: "jarobak Index",
        value: jarobakIndex.toFixed(2) + "  %  ",
      },
      {
        key: "YAxis",
        label: "YAxis",
        value: YAxis.toFixed(2),
      },
      {
        key: "ANB Degree",
        label: "ANB Degree",
        value: ANBDegree.toFixed(2),
      },
      {
        key: "ArticularAngle",
        label: "Articular Angle",
        value: ArticularAngle.toFixed(2),
      },
      {
        key: "SNA   angle",
        label: "SNAangle",
        value: SNAangle.toFixed(2),
      },
      {
        key: "SNB  angle",
        label: "SNB  angle",
        value: SNBangle.toFixed(2),
      },
      {
        key: "SN-FH  angle",
        label: "SN-FH   angle",
        value: SNFHAngle.toFixed(2),
      },
      {
        key: "SN-GoMe  angle",
        label: "SN-GoMe   angle",
        value: SN_GoMeAngle.toFixed(2),
      },
      {
        key: "FH - GoMe  angle",
        label: "FH - GoMe   angle",
        value: FHMeGo.toFixed(2),
      },
      {
        key: "SN_GoGn  angle",
        label: "SN_GoGn   angle",
        value: SN_GoGn.toFixed(2),
      },
    ]);
  };

  const calculateDistance = (point1, point2) => {
    const dx = point2.x - point1.x;
    const dy = point2.y - point1.y;
    return Math.sqrt(dx * dx + dy * dy);
  };

  const calculateAngle = (pointA, pointB, pointC) => {
    let dAB = calculateDistance(pointA, pointB);
    let dAC = calculateDistance(pointA, pointC);
    let dBC = calculateDistance(pointB, pointC);
    let acosTeta = (dAB ** 2 + dBC ** 2 - dAC ** 2) / (2 * dAB * dBC);
    let tettaRad = Math.acos(acosTeta);
    let tetaDegree = tettaRad * (180 / Math.PI);
    return tetaDegree;
  };
  const calculateSignedAngle = (pointA, pointB, pointC) => {
    const vectorAB = { x: pointB.x - pointA.x, y: pointB.y - pointA.y };
    const vectorBC = { x: pointC.x - pointB.x, y: pointC.y - pointB.y };

    const dotProduct = vectorAB.x * vectorBC.x + vectorAB.y * vectorBC.y;
    const crossProduct = vectorAB.x * vectorBC.y - vectorAB.y * vectorBC.x;

    const magnitudeAB = Math.sqrt(vectorAB.x ** 2 + vectorAB.y ** 2);
    const magnitudeBC = Math.sqrt(vectorBC.x ** 2 + vectorBC.y ** 2);

    let acosTeta = dotProduct / (magnitudeAB * magnitudeBC);

    // Ensure acosTeta is within the valid range [-1, 1]
    acosTeta = Math.max(-1, Math.min(1, acosTeta));

    let tettaRad = Math.acos(acosTeta);

    // Determine the sign of the angle based on the cross product
    if (crossProduct < 0) {
      tettaRad = -tettaRad;
    }

    // Convert angle to degrees
    let tetaDegree = tettaRad * (180 / Math.PI);

    if (tetaDegree < 0) {
      tetaDegree = 180 + tetaDegree;
    } else {
      tetaDegree = tetaDegree - 180;
    }

    return tetaDegree;
  };
  const _onstop = (event, data, label) => {
    let x = parseInt(data.x.toFixed());
    let y = parseInt(data.y.toFixed());
    console.log(x, y, label);
    console.log(data);

    setPointPositions((prevPositions) => ({
      ...prevPositions,
      [label]: { x: x, y: y },
    }));
  };

  const calculateAngleBetweenLines = (pointA, pointB, pointC, pointD) => {
    // Calculate the vectors AB and CD
    let vectorAB = { x: pointB.x - pointA.x, y: pointB.y - pointA.y };
    let vectorCD = { x: pointD.x - pointC.x, y: pointD.y - pointC.y };

    // Calculate the dot product of AB and CD
    let dotProduct = vectorAB.x * vectorCD.x + vectorAB.y * vectorCD.y;

    // Calculate the magnitudes of AB and CD
    let magnitudeAB = Math.sqrt(vectorAB.x ** 2 + vectorAB.y ** 2);
    let magnitudeCD = Math.sqrt(vectorCD.x ** 2 + vectorCD.y ** 2);

    // Calculate the angle between the vectors using the dot product formula
    let cosTheta = dotProduct / (magnitudeAB * magnitudeCD);
    let thetaRad = Math.acos(cosTheta);
    let thetaDegree = thetaRad * (180 / Math.PI);
    return thetaDegree;
  };

  const _returnDraggbleView = () => {
    let _output = [];
    for (let key in pointPositions) {
      _output.push(
        <Draggable
          onStop={(event, data) => _onstop(event, data, key)}
          // bounds="parent"
          defaultPosition={pointPositions[key]}
          position={pointPositions[key]}
        >
          <div className="DragableContainer">
            <div className="circlePoint" />
            {/* <div className="linewithAngle" /> */}
            <div className="labelPoint">{key}</div>
          </div>
        </Draggable>
      );
    }
    return _output;
  };

  useEffect(() => {
    // alert(typeAnalyses);
    if (idAnalyses == undefined) {
      GetPatientLaterallPhoto();
    } else {
      GetPatientLaterallPhotoForEdit();
    }
    // GetPatientLaterallPhoto();
  }, []);

  const GetPatientLaterallPhoto = async () => {
    let url = Url.getPatientLateralPhoto;

    let res = await props.actions.CallCoreServicesActionWithToken(url, { id });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    if (res.data?.patientImages.length > 0) {
      let newPos = { ...pointPositions };
      let img = res.data?.patientImages[0];
      //for in newpos
      for (let key in newPos) {
        newPos[key].x = Math.floor(newPos[key].x * (img.imageWidth / 834));
        newPos[key].y = Math.floor(newPos[key].y * (img.imageHeight / 1000));
      }

      setPointPositions(newPos);

      console.log("new pos", newPos);
      setLateralPhoto(res.data?.patientImages[0]);
    }
  };

  const GetPatientLaterallPhotoForEdit = async () => {
    let url = Url.lateral_GetPhotoForEdit;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      IdPateint: id,
      IdAnalyses: idAnalyses,
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    if (res.data?.patientImages.length > 0) {
      setLateralPhoto(res.data?.patientImages[0]);
    }

    if (res.data?.lateralCephaloAnalyses?.length > 0) {
      let analyses = res.data?.lateralCephaloAnalyses[0];
      let List_Position = analyses.lateralCephaloPositions;
      let _newPosistion = {};

      List_Position.map((Object) => {
        if (Object.type == "OP2") {
          // _newPosistion["U1"] = {
          //   x: Object.xposition + 3,
          //   y: Object.yposition + 2,
          // };
          // _newPosistion["L1"] = {
          //   x: Object.xposition - 2,
          //   y: Object.yposition - 2,
          // };
          return;
        }
        _newPosistion[Object.type] = {
          x: Object.xposition,
          y: Object.yposition,
        };
      });

      for (const key in pointPositions) {
        if (_newPosistion[key] == undefined) {
          _newPosistion[key] = _newPositionOfNewPoint(key, _newPosistion);
        }
      }

      console.log("old position", pointPositions);
      console.log("new pos", _newPosistion);
      setPointPositions(_newPosistion);
    }
  };

  const _newPositionOfNewPoint = (key, newPosition) => {
    if (key == "SoftG") {
      let f = newPosition["N"];
      return { x: f.x + 10, y: f.y - 50 };
    }
    if (key == "SoftPn") {
      let f = newPosition["ANS"];
      if (f) return { x: f.x + 40, y: f.y };
    }
    if (key == "SoftPOG") {
      let f = newPosition["POG"];
      if (f) return { x: f.x + 40, y: f.y };
    }
    if (key == "SoftMe") {
      let f = newPosition["Me"];
      if (f) return { x: f.x, y: f.y + 40 };
    }
    if (key == "SoftULip") {
      let f = newPosition["U1"];
      if (f) return { x: f.x + 40, y: f.y };
    }
    if (key == "SoftLLip") {
      let f = newPosition["L1"];
      if (f) return { x: f.x + 40, y: f.y };
    }
    return { x: 200, y: 40 };
  };
  const _SaveAnalyses = async () => {
    let url = Url.saveLateralAnalyses;

    let lateralCephaloPositions = [];
    for (let key in pointPositions) {
      lateralCephaloPositions.push({
        type: key,
        xposition: pointPositions[key].x,
        yposition: pointPositions[key].y,
      });
    }

    let id = parseInt(idAnalyses);

    let data = {
      id: id ? id : 0,
      patientId: lateralPhoto.patientId,
      patientImageId: lateralPhoto.id,
      lateralCephaloPositions: lateralCephaloPositions,
    };

    let res = await props.actions.CallCoreServicesActionWithToken(url, data);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }

    message.success(res.message);
    navigate("/lateralchephalo/main");
  };

  const _PredictWithAi = async () => {
    let url = Url.GetPointWithAiWithId;
    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      id: id,
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }

    let parseJson = JSON.parse(res.data);

    let newPos = { ...pointPositions };

    for (let key in newPos) {
      let IsFindAi = parseJson.find((x) => x.name == key);
      if (IsFindAi) {
        newPos[key].x = IsFindAi.x;
        newPos[key].y = IsFindAi.y;
      } else {
        // api.warning({
        //   message: `Not Found This point`,
        //   description: <div> {key}</div>,
        // });
      }
    }
    let OP2 = parseJson.find((x) => x.name == "OP2");
    if (OP2) {
      newPos["U1"] = { x: OP2.x + 3, y: OP2.y + 2 };
      newPos["L1"] = { x: OP2.x - 2, y: OP2.y - 2 };
    }

    for (const key in pointPositions) {
      if (newPos[key] == undefined) {
        newPos[key] = _newPositionOfNewPoint(key, newPos);
      }
    }

    setPointPositions(newPos);
  };

  return (
    <div dir="ltr">
      <Button onClick={_PredictWithAi}>Predict With Ai</Button>
      {contextHolder}
      {lateralPhoto != null && (
        <>
          <div
            style={{
              backgroundColor: "red",
              position: "relative",
              width: lateralPhoto.imageWidth,
              height: lateralPhoto.imageHeight,
            }}
          >
            <img
              src={ImagePreAddress + lateralPhoto.imageUrl}
              className="imageCephalo"
              draggable={false}
            />
            {_returnDraggbleView()}
          </div>
          <ConfigProvider direction="ltr">
            <Descriptions bordered title="Lateral Cephalo Analyses">
              {LateralCephaloAnaLysis.map((item) => {
                return (
                  <Descriptions.Item key={item.key} label={item.label}>
                    {item.value}
                  </Descriptions.Item>
                );
              })}
            </Descriptions>
          </ConfigProvider>
          <Button
            loading={
              props.coreData[Url.saveLateralAnalyses]?.[Url.action]?.isFetching
            }
            type="primary"
            onClick={() => _SaveAnalyses()}
          >
            {idAnalyses == undefined ? "Save " : "Update "} Analyses
          </Button>
        </>
      )}
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LateralCephaloAnaLysis);
